import { Route } from "legacy/DFE/routing/RouterTypes";
import { State } from "legacy/DFE/store/state";
import { selectors } from "legacy/DFE/store/UXFlow";

export abstract class OnboardingRoute extends Route {
    async precondition(state: State): Promise<boolean> {
        return selectors.flow(state).next === this.name;
    }
}